import React from 'react'
import Head from 'next/head'
import { config } from '@/config'

const AirdropTitle = () => {
  return (
    <Head>
      <title>{config.app.title} | Airdrop</title>
    </Head>
  )
}

export { AirdropTitle }
